module.exports = __webpack_public_path__ + "img/download.ab9f5360.png";